<template>
  
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      groupId: this.$route.params.groupId,
      fileId: this.$route.params.fileId,
      fileName: ''
    }
  },
  mounted() {
    let obj = this;
    obj.getFileInfo();
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    // 파일 정보 조회
    getFileInfo() {
      let obj = this;
      let reqData = {
        url: '/api/cofile/cofile/getFileInfo',
        method: 'post',
        req: {
          groupId : obj.groupId,
          fileId : obj.fileId
        }
      };

      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if(errorCode == null) {
            // 파일명 세팅 후 파일 다운로드 API 호출
            obj.fileName = res.result.fileInfo.fileName;
            obj.downloadFile();
          } else {
            console.log(errorCode);
            if(errorCode == "NOT_AUTHORIZED") {
              alert(obj.$i18nUtil.trans("TB044")); // 권한 없음 // iframe
              //window.opener.alert(obj.$i18nUtil.trans("TB044")); // 권한 없음 // window.open
            } else {
              alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // iframe
              //window.opener.alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // window.open
            }
            //self.close(); // 팝업창 닫기 // window.open
          }
        })
        .catch(function(err) {
          console.log(err);
          alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // iframe
          //window.opener.alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // window.open
          //self.close(); // 팝업창 닫기 // window.open
        });

    },
    // 파일 다운로드
    downloadFile() {
      let obj = this;
      let fileName = obj.fileName;
      let param = {};
      param.groupId = obj.groupId;
      param.fileId = obj.fileId;
      param.type = 'SINGLE';
      param.groupKbn = 'PRO';

      obj.$axios({
        url: "/api/cofile/cofile/download",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        data: param
      })
      .then(res => {
        try {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"]
          });

          // 에러코드 체크
          if(res.data.type.startsWith("application/json")) {
            let errorCode = obj.blobToString(blob);
            if(errorCode == "NOT_AUTHORIZED") {
              alert(obj.$i18nUtil.trans("TB044")); // 권한 없음 // iframe
              //window.opener.alert(obj.$i18nUtil.trans("TB044")); // 권한 없음 // window.open
            } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
              alert(obj.$i18nUtil.trans("AB101")); // 외부망에서 다운로드 불가 // iframe
              //window.opener.alert(obj.$i18nUtil.trans("AB101")); // 외부망에서 다운로드 불가 // window.open
            } else {
              alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // iframe
              //window.opener.alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // window.open
            }
            //self.close(); // 팝업창 닫기 // window.open
          } else {
            if (window.navigator.msSaveOrOpenBlob) {
              // IE에서 window.open 팝업창으로 열 경우 부모창에서 다운로드 창이 띄워지지 않음
              window.navigator.msSaveOrOpenBlob(blob, fileName);
              //self.close(); // 팝업창 닫기 // window.open
            } else {
              let link = document.createElement("a");
              //link.target = "_parent"; // window.open
              link.target = "_self"; // iframe
              link.setAttribute("download", fileName);
              link.href = window.URL.createObjectURL(blob);
              link.click();
              link.remove();
              //self.close(); // 팝업창 닫기 // window.open
            }
          }
        } catch (e) {
          console.error(e);
          alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // iframe
          //window.opener.alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // window.open
          //self.close(); // 팝업창 닫기 // window.open
        }
      })
      .catch(res => {
        console.log(res);
        alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // iframe
        //window.opener.alert(obj.$i18nUtil.trans("AB077")); // 다운로드 실패 // window.open
        //self.close(); // 팝업창 닫기 // window.open
      })
    },
    // blob To string
    blobToString(blob) {
      let u, x;
      u = URL.createObjectURL(blob);
      x = new XMLHttpRequest();
      x.open('GET', u, false);
      x.send();
      URL.revokeObjectURL(u);
      return x.responseText;
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/feedback/download/FeedbackFileDownload.vue